import * as Logos from "../../../svgs/logos";

function Logo({ name, ...props }) {
  switch (name) {
    case "endr":
      return <Logos.EndrLogo {...props} />;
    case "apa":
      return <Logos.APALogo {...props} />;
    case "lifehealth":
      return <Logos.LifeHealthLogo {...props} />;
    case "channelview":
      return <Logos.ChannelViewLogo {...props} />;
    case "nooro":
      return <Logos.NooroLogo {...props} />;
    case "OrchardView":
      return <Logos.OrchardViewLogo {...props} />;
    case "houstoncc":
      return <Logos.HoustonCCLogo {...props} />;
    case "mike":
      return <Logos.DailyDoseLogo {...props} />;
    case "primer":
      return <Logos.PrimerLogo {...props} />;
    case "capella":
      return <Logos.CapellaLogo {...props} />;
    case "asu":
      return <Logos.ASULogo {...props} />;
    case "chemonics":
      return <Logos.ChemonicsLogo {...props} />;
    case "verumseminary":
      return <Logos.VerumSeminaryLogo {...props} />;
    case "academica":
      return <Logos.AcademicaLogo {...props} />;
    case "imentor":
      return <Logos.IMentorLogo {...props} />;
    case "axio":
      return <Logos.AxioLogo {...props} />;
    case "axiodemo":
      return <Logos.AxioDemoLogo {...props} />;
    case "cuesta":
      return <Logos.CuestaLogo {...props} />;
    case "parable":
      return <Logos.ParableLogo {...props} />;
    case "jessup":
      return <Logos.JessupLogo {...props} />;
    case "umich":
      return <Logos.UMichLogo {...props} />;
    case "lighthouse":
      return <Logos.BelhavenLogo {...props} />;
    case "quitumbe":
      return <Logos.QuitumbeLogo {...props} />;
    case "gmi":
      return <Logos.GMILogo {...props} />;
    case "azcyber":
      return <Logos.AzCyberLogo {...props} />;
    case "jessuponline":
      return <Logos.JessupOnlineLogo {...props} />;
    case "inspirework":
      return <Logos.InspireWorkLogo {...props} />;
    default:
      return null;
  }
}

export default Logo;
